import type { ApiClient } from '../client';
import { UserDeviceSchema, type UserDevice } from '../schemas/userDevice';

export async function fetchUserDevice(client: ApiClient, id: string): Promise<UserDevice | null> {
  const data = await client.get<unknown>(
    `/app_service/panel/v1/users/${encodeURIComponent(id)}/device`,
  );
  // "No device" (web-only / never installed the app) is an empty 200 body (→ undefined
  // here) — the ficha renders em-dash rows. A populated body is the device object itself.
  if (data == null) return null;
  return UserDeviceSchema.parse(data);
}
